import { render } from "./Statistik.vue?vue&type=template&id=de6760b0"
import script from "./Statistik.vue?vue&type=script&lang=js"
export * from "./Statistik.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__